import { Component, Input, OnInit } from '@angular/core';
import { EventType } from '../../../../../../../../models/event-type';
import { EventTypeService } from '../../../../../../../../services/event-type/event-type.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-duplicate-event-type-modal',
  templateUrl: './duplicate-event-type-modal.component.html',
  styleUrls: ['./duplicate-event-type-modal.component.css']
})
export class DuplicateEventTypeModalComponent implements OnInit {

  @Input() eventType: EventType;
  @Input() savedCallback: (newEventTypeId: number) => undefined;

  public name = '';

  public loadingSubmit = false;
  public errorMessage = '';

  constructor(
    public activeModal: NgbActiveModal,
    private eventTypeService: EventTypeService,
  ) {}

  ngOnInit() {
    this.name = 'Copy of ' + this.eventType.name;
  }

  public handleSubmit() {
    this.loadingSubmit = true;

    this.eventTypeService
      .duplicateEventType(this.eventType.id, this.name)
      .then(newEventTypeId => {
        this.savedCallback(newEventTypeId);
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to duplicate this event type.';
        } else {
          this.errorMessage = 'Server error: ' + reason.status.toString();
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
